import * as CommonController from "./modules/common.module";

export const Service = {
  CommonController: CommonController,
};

export default Service;
